import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function base64ToDataUrl(base64: string): string {
  // If it's already a data URL, return as is
  if (base64.startsWith('data:')) {
    return base64;
  }
  // Otherwise, convert base64 string to data URL
  return `data:image/jpeg;base64,${base64}`;
}
